/* eslint-disable no-undef */
import axios from '@axios'

export const state = {
  carriers: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecords: 1,
}
export const getters = {
  allCarriers: (state) => state.carriers,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPage: (state) => state.totalPage,
  totalRecords: (state) => state.totalRecords,
}
export const mutations = {
  GET_CARRIERS: (state, data) => {
    // if (!data) return false
    state.carriers = data.carriers
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPage = data.totalPages
    state.totalRecords = data.totalRecords
  },
  CREATE_CARRIER: (state, carrier) => {
    state.carriers.unshift(carrier)
  },
  UPDATE_CARRIER: (state, carrier) => {
    state.carriers = state.carriers.filter(c => c.id !== carrier.id)
    state.carriers.unshift(carrier)
  },
  TOGGLE_CARRIER: (state, carrier) => {
    for (let i = 0; i < state.carriers.length; i++) {
      if (state.carriers[i].id === carrier.id) {
        state.carriers[i].status = carrier.status
        break
      }
    }
  },
  REMOVE_CARRIER: (state, carrier) => {
    state.carriers = state.carriers.filter(c => c.id !== carrier.id)

  },
}

export const actions = {
  async getCarriers({ commit }, params = {}) {
    let { _commit } = params
    if (typeof (_commit) === 'boolean' && _commit === false) {
      return axios.get('/sms/carriers', { params: params })
    }
    await axios.get('/sms/carriers', { params: params }).then(resp => {
      if (resp.status === 200) {
        commit("GET_CARRIERS", resp.data)
      }
    })
  },
  async getCarrier({ commit }, carrier) {
    return axios.get(`/sms/carrier/${carrier.id}`)
  },
  async updateCarrier({ commit }, carrier) {
    await axios
      .put(`/sms/carrier/${carrier.id}`, carrier)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_CARRIER', resp.data)
        }
      })
  },
  async createCarrier({ commit }, carrier) {
    await axios
      .post('/sms/carrier', carrier)
      .then((resp) => {
        if (resp.status === 201) {
          commit('CREATE_CARRIER', resp.data)
        }
      })
  },
  async toggleCarrier({ commit }, carrier) {
    await axios
      .patch(`/sms/carrier/${carrier.id}`)
      .then((resp) => {
        if (resp.status === 200) {
          commit('TOGGLE_CARRIER', resp.data)
        }
      })
  },
  async removeCarrier({ commit }, carrier) {

    await axios
      .delete(`/sms/carrier/${carrier.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_CARRIER', carrier)
        }
      })
  },
}
